import React from 'react';
import { QueryClientProvider } from 'react-query';
import { getSharedQueryClient, setQueryClientDefaultQueryOptions } from '../Utils/queryClientInstance';
import { getSharedPremiumResource } from '../../premium-api/getSharedPremiumResource';
import { PremiumSharedResource } from '../../premium-api/types';
import { useWillMount } from '../../react-utils/Hooks';
import { usePremiumEssentialsContext } from '../../premium-essentials/PremiumEssentialsProvider';
const ApisClientContext = getSharedPremiumResource(PremiumSharedResource.ApisClientContext, () => /*#__PURE__*/React.createContext({}));
export const ApisClientProvider = _ref => {
  var _usePremiumEssentials, _ref2;
  let {
    children,
    httpClient: httpClientFromArgs,
    ...defaultQueryOptions
  } = _ref;
  const {
    values: existingValues
  } = React.useContext(ApisClientContext);
  const httpClientFromExisting = existingValues == null ? void 0 : existingValues.httpClient;
  const queryClient = getSharedQueryClient();
  const {
    hasErrorBoundary,
    httpClient: httpClientFromEssentials
  } = (_usePremiumEssentials = usePremiumEssentialsContext(false)) != null ? _usePremiumEssentials : {};
  useWillMount(() => {
    var _defaultQueryOptions$;
    const prevOptions = setQueryClientDefaultQueryOptions({
      ...defaultQueryOptions,
      useErrorBoundary: (_defaultQueryOptions$ = defaultQueryOptions == null ? void 0 : defaultQueryOptions.useErrorBoundary) != null ? _defaultQueryOptions$ : hasErrorBoundary
    });
    return () => {
      setQueryClientDefaultQueryOptions(prevOptions);
    };
  }, [hasErrorBoundary]);
  if (httpClientFromExisting && httpClientFromArgs) {
    console.debug("Note that you're supplying a redundant httpClient via <ApiProvider />, previous httpClient was already supplied in the root provider");
  }
  const httpClient = (_ref2 = httpClientFromExisting != null ? httpClientFromExisting : httpClientFromArgs) != null ? _ref2 : httpClientFromEssentials;
  if (!httpClient) {
    console.error('<ApiProvider> with valid httpClient was not supplied ');
  }
  return /*#__PURE__*/React.createElement(ApisClientContext.Provider, {
    value: {
      values: {
        httpClient
      }
    }
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient,
    contextSharing: true
  }, children));
};
export const useApisClientContext = () => {
  const {
    values
  } = React.useContext(ApisClientContext);
  if (!values) {
    throw new Error('<ApisClientProvider> was not initialize before calling "useApiContext", please add <ApisClientProvider> to your root component');
  }
  return values;
};
//# sourceMappingURL=ApisClientProvider.js.map